import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#030305] flex items-center justify-center px-6 grid-radial">
      <div className="grain" />
      <motion.form
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        onSubmit={submit}
        className="w-full max-w-sm border border-white/10 bg-[#0A0A0C] p-8 relative z-10"
        data-testid="admin-login-form"
      >
        <p className="font-display font-black text-2xl tracking-tighter mb-1">POLYON<span className="text-[#00F0FF]">//</span>PEPS</p>
        <p className="text-[10px] uppercase tracking-widest text-[#00F0FF] font-mono2 mb-8">Admin Access</p>

        {error && <p className="text-[#FF003C] text-xs font-mono2 mb-4" data-testid="login-error">{error}</p>}

        <label className="text-[10px] uppercase tracking-widest text-slate-400 font-mono2">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="mt-1 mb-4 w-full bg-black border border-white/15 focus:border-[#00F0FF] outline-none px-3 py-2.5 text-sm font-mono2" data-testid="login-email" />

        <label className="text-[10px] uppercase tracking-widest text-slate-400 font-mono2">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="mt-1 mb-6 w-full bg-black border border-white/15 focus:border-[#00F0FF] outline-none px-3 py-2.5 text-sm font-mono2" data-testid="login-password" />

        <button type="submit" disabled={loading}
          className="w-full bg-[#00F0FF] text-black py-3 text-xs uppercase tracking-widest font-bold font-mono2 disabled:opacity-50" data-testid="login-submit">
          {loading ? "Authenticating…" : "Sign In"}
        </button>
      </motion.form>
    </div>
  );
}
